import { Controller } from '@hotwired/stimulus';

/**
 * ScreeningOptionController
 *
 * 投資適合性選択肢の「登録をブロックする」チェックボックスと
 * 警告メッセージ入力エリアの表示/非表示を制御するコントローラー
 *
 * また、回答方式（単一/複数/テキスト）に応じて、
 * 全ての選択肢のブロック設定UIを一括で表示/非表示する
 */
export default class extends Controller {
  static targets = ['checkbox', 'messageArea'];
  static answerTypeListenerInitialized = false;

  connect() {
    // feature flagがOFFの場合、ターゲットが描画されないため早期リターン
    if (!this.hasCheckboxTarget || !this.hasMessageAreaTarget) {
      return;
    }

    // 初期状態でチェックボックスの状態に応じて表示を制御
    this.toggle();

    // この要素のブロック設定エリアの初期表示を設定
    this.updateBlockingAreaVisibility();

    // 回答方式の監視は最初のインスタンスだけが行う（重複防止）
    if (!this.constructor.answerTypeListenerInitialized) {
      this.setupAnswerTypeListener();
      this.constructor.answerTypeListenerInitialized = true;
    }
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.messageAreaTarget.classList.remove('d-none');
    } else {
      this.messageAreaTarget.classList.add('d-none');
    }
  }

  /**
   * この要素のブロック設定エリアの表示/非表示を更新
   * 現在選択されている回答方式に基づいて表示を制御
   */
  updateBlockingAreaVisibility() {
    const answerTypeRadios = document.querySelectorAll('input[name*="[answer_type]"]');
    const selected = Array.from(answerTypeRadios).find(r => r.checked);
    const isSingle = selected?.value === 'single';
    const blockingArea = this.element.querySelector('[data-blocking-area]');

    if (blockingArea) {
      if (isSingle) {
        blockingArea.classList.remove('d-none');
      } else {
        blockingArea.classList.add('d-none');
      }
    }
  }

  /**
   * 回答方式のラジオボタンを監視し、
   * 単一回答の場合のみ全てのブロック設定UIを表示
   */
  setupAnswerTypeListener() {
    const answerTypeRadios = document.querySelectorAll('input[name*="[answer_type]"]');

    const updateAllBlockingAreas = () => {
      const selected = Array.from(answerTypeRadios).find(r => r.checked);
      const isSingle = selected?.value === 'single';
      const blockingAreas = document.querySelectorAll('[data-blocking-area]');

      blockingAreas.forEach(area => {
        if (isSingle) {
          area.classList.remove('d-none');
        } else {
          area.classList.add('d-none');
        }
      });
    };

    answerTypeRadios.forEach(r => r.addEventListener('change', updateAllBlockingAreas));
  }
}
